/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { SpoofObstacleInternal } from "../../../../gen/skills/spoof_obstacle_internal";

export const protobufPackage = "skills";

export interface SpoofObstacleActionArgs {
  spoofObstacleInternal: SpoofObstacleInternal | undefined;
}

export interface SpoofObstacleResultData {
}

export interface SpoofObstacleActionStateData {
}

function createBaseSpoofObstacleActionArgs(): SpoofObstacleActionArgs {
  return { spoofObstacleInternal: undefined };
}

export const SpoofObstacleActionArgs = {
  encode(message: SpoofObstacleActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.spoofObstacleInternal !== undefined) {
      SpoofObstacleInternal.encode(message.spoofObstacleInternal, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofObstacleActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofObstacleActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.spoofObstacleInternal = SpoofObstacleInternal.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofObstacleActionArgs {
    return {
      spoofObstacleInternal: isSet(object.spoofObstacleInternal)
        ? SpoofObstacleInternal.fromJSON(object.spoofObstacleInternal)
        : undefined,
    };
  },

  toJSON(message: SpoofObstacleActionArgs): unknown {
    const obj: any = {};
    if (message.spoofObstacleInternal !== undefined) {
      obj.spoofObstacleInternal = SpoofObstacleInternal.toJSON(message.spoofObstacleInternal);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofObstacleActionArgs>, I>>(base?: I): SpoofObstacleActionArgs {
    return SpoofObstacleActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofObstacleActionArgs>, I>>(object: I): SpoofObstacleActionArgs {
    const message = createBaseSpoofObstacleActionArgs();
    message.spoofObstacleInternal =
      (object.spoofObstacleInternal !== undefined && object.spoofObstacleInternal !== null)
        ? SpoofObstacleInternal.fromPartial(object.spoofObstacleInternal)
        : undefined;
    return message;
  },
};

function createBaseSpoofObstacleResultData(): SpoofObstacleResultData {
  return {};
}

export const SpoofObstacleResultData = {
  encode(_: SpoofObstacleResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofObstacleResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofObstacleResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofObstacleResultData {
    return {};
  },

  toJSON(_: SpoofObstacleResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofObstacleResultData>, I>>(base?: I): SpoofObstacleResultData {
    return SpoofObstacleResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofObstacleResultData>, I>>(_: I): SpoofObstacleResultData {
    const message = createBaseSpoofObstacleResultData();
    return message;
  },
};

function createBaseSpoofObstacleActionStateData(): SpoofObstacleActionStateData {
  return {};
}

export const SpoofObstacleActionStateData = {
  encode(_: SpoofObstacleActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofObstacleActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofObstacleActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofObstacleActionStateData {
    return {};
  },

  toJSON(_: SpoofObstacleActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofObstacleActionStateData>, I>>(base?: I): SpoofObstacleActionStateData {
    return SpoofObstacleActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofObstacleActionStateData>, I>>(_: I): SpoofObstacleActionStateData {
    const message = createBaseSpoofObstacleActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
